import { createSelector } from 'reselect';
import { RootState } from 'store';
import { REDUCER_KEY } from './products.consts';
import { ProductParams } from './products.types';

export function selectSelectedIds(state: RootState): number[] {
  return state[REDUCER_KEY].selected.map(({ id }: { id: number }) => id);
}

export function selectSelectedProducts(state: RootState): ProductParams[] {
  return state[REDUCER_KEY].selected;
}

export const selectSelectedProductsIdNames = createSelector(
  state => selectSelectedProducts(state),
  products =>
    products.map(({ id, generalValue: { name } }) => ({
      id,
      name,
    })),
);

export const selectErrorIds = createSelector(
  state => selectSelectedProducts(state),
  state => state[REDUCER_KEY].errorIds,
  (selected, errorIds) =>
    selected.map(product => product.id).filter(id => errorIds.includes(id)),
);
